export default __webpack_public_path__ + "static/media/innergy.825d940c.png";